import React from 'react';

const InputField = ({
  label,
  name,
  value,
  onChange,
  as = 'input',
  className = '',
  labelClassName = 'block text-sm font-medium text-gray-700 mb-1',
  ...props
}) => (
  <div className="mb-4">
    {label && (
      <label htmlFor={name} className={labelClassName}>
        {label}
      </label>
    )}
    {as === 'textarea' ? (
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        rows={props.rows || 3}
        className={`form-field w-full rounded-md border border-gray-300 focus:ring focus:ring-blue-100 focus:outline-none p-2 ${className}`}
        {...props}
      />
    ) : (
      <input
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        className={`form-field h-10 w-full rounded-md border border-gray-300 focus:ring focus:ring-blue-100 focus:outline-none px-3 ${className}`}
        {...props}
      />
    )}
  </div>
);

export default InputField;
